import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Search } from 'lucide-react';

// Search input da barra superior do storefront. Submit (enter) ou
// debounce 600ms navega pra `/catalogo?q=...`. ⌘K / Ctrl+K dá foco.
const SearchBar = ({ placeholder = 'Buscar produtos, marcas...', debounceMs = 600 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('q') || '';
  });
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  const submit = (q) => {
    const trimmed = (q || '').trim();
    const params = new URLSearchParams();
    if (trimmed) params.set('q', trimmed);
    navigate(`/catalogo${params.toString() ? `?${params}` : ''}`);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setValue(v);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      // Só auto-submete quando o usuário já está em /catalogo (live filter).
      // Em outras telas, exigimos enter pra evitar navegação inesperada.
      if (location.pathname.startsWith('/catalogo')) submit(v);
    }, debounceMs);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (timerRef.current) clearTimeout(timerRef.current);
    submit(value);
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className="absolute inset-y-0 left-2.5 flex items-center pointer-events-none text-app-text-secondary">
        <Search size={16} />
      </div>
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        aria-label="Buscar"
        className="w-full pl-9 pr-14 py-2 bg-white border border-app-border rounded-md text-sm text-app-text placeholder:text-app-text-secondary focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all"
      />
      <kbd className="hidden sm:flex absolute right-3 top-1/2 -translate-y-1/2 items-center gap-1 text-xs text-app-text-secondary border border-app-border rounded px-1.5 py-0.5 bg-app-surface">
        ⌘K
      </kbd>
    </form>
  );
};

export default SearchBar;
